module.exports = __webpack_public_path__ + "static/obama_naked-817cd74c34c7a845b8f7b6f6087a16b9.jpg";